import { service } from '../index.js'

// 订单
export const order = {
  // 创建订单
  create: (data) => {
    return service.post('/order/create', data)
  },
  
  // 获取订单列表
  list: (params) => {
    return service.get('/order/list', { params })
  },
  
  // 获取订单详情
  detail: (id) => {
    return service.get(`/order/detail/${id}`)
  },
  
  // 取消订单
  cancel: (data) => {
    return service.post('/order/cancel', data)
  },
  
  // 确认收货
  confirm: (data) => {
    return service.post('/order/confirm', data)
  },
  
  // 获取订单统计
  statistics: () => {
    return service.get('/order/statistics')
  },
  
  // 后台：订单列表
  adminList: (params) => {
    return service.get('/order/admin/list', { params })
  },
  
  // 后台：发货
  ship: (data) => {
    return service.post('/order/admin/ship', data)
  },
  
  // 后台：改价
  changePrice: (data) => {
    return service.post('/order/admin/changePrice', data)
  },
  
  // 后台：备注
  remark: (data) => {
    return service.post('/order/admin/remark', data)
  },

  // 后台：处理退款申请（action: 'approve'=同意, 'reject'=拒绝）
  handleRefund: (data) => {
    return service.post('/order/admin/handleRefund', data)
  },

  // 后台：统计数据
  adminStatistics: () => {
    return service.get('/order/admin/statistics')
  },
  
  // 后台：物流查询（type: 'out'=发货物流, 'refund'=退货物流）
  express: (orderId, type = 'out') => {
    return service.get('/order/admin/express', { params: { order_id: orderId, type } })
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/order.js